// @flow

import React, { useState, useEffect, useCallback } from "react";

import Modal, { OvalModalWrap, CloseModalIcon } from "../Modal";
import Button from "../ButtonDefault";
import * as Style from "./styledComponents";

import apiMethod from "../../api/apiMethod";
import { __ } from "../../lib/translate";
import { errorKeys } from "../../lib/errors";
import hashManager from "../../lib/hashManager";

const DeleteTokenModal = ({
  opened,
  onClose,
  onSuccess,
  id = 0,
  deviceName,
  createdDate,
  isCurrent = false
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (opened) {
      document.addEventListener("keyup", onEnter);
    } else {
      document.removeEventListener("keyup", onEnter);
    }
  }, [opened]);

  const onEnter = useCallback(
    (e: any) => {
      if (e.keyCode === 13) {
        onDeleteTokenClick();
      }
    },
    [onDeleteTokenClick]
  );

  const onDeleteTokenClick = () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    apiMethod(
      "deletetoken",
      { tokenid: id },
      () => {
        setIsLoading(false);
        if (isCurrent) {
          HFN.pages.goto("login");
        } else {
          HFN.message(__("Token Deleted."));
          hashManager.pushState({ refr: uniqueNum.get() });
        }
        onSuccess(id);
        onClose();
      },
      {
        errorCallback: ({ result, error }) => {
          if (errorKeys[result]) {
            HFN.message(__(errorKeys[result]), "error");
          } else {
            onClose();
            HFN.message(__("something_went_wrong_refresh_and_try_again"), "error");
            throw new Error(error);
          }
        }
      }
    );
  };

  return (
    <Modal animate onClose={onClose} opened={opened}>
      <OvalModalWrap>
        <CloseModalIcon onClick={onClose} />
        <Style.Container>
          <Style.Header>{__("Delete Token")}</Style.Header>
          <Style.Box className="responsive">
            <Style.WrapperElements>
              <Style.ElementBold className="nowrap">{__("Device")}</Style.ElementBold>
              <Style.ElementBold className="nowrap">{__("Created")}</Style.ElementBold>
            </Style.WrapperElements>
            <Style.WrapperElements>
              <Style.ElementUnderLine>{deviceName}</Style.ElementUnderLine>
              <Style.ElementUnderLine>{createdDate}</Style.ElementUnderLine>
            </Style.WrapperElements>
          </Style.Box>
          <Style.Footer>
            <Button
              color="lightgray4"
              style={{
                marginRight: "5px"
              }}
              onClick={onClose}
            >
              {__("Cancel")}
            </Button>
            <Button
              loading={isLoading}
              disabled={isLoading}
              color="red"
              style={{
                marginLeft: "5px"
              }}
              disabledColor="#dddddd"
              onClick={onDeleteTokenClick}
            >
              {__("Delete")}
            </Button>
          </Style.Footer>
        </Style.Container>
      </OvalModalWrap>
    </Modal>
  );
};

export default DeleteTokenModal;
